module.exports = __webpack_public_path__ + "static/media/block.274da01e.svg";